// import produce from 'immer';
// @ts-nocheck
import { useEffect, useState } from 'react';
import { RJSFSchema } from '@rjsf/utils';
import existingClientGroupForm from '../components/ClientGroups/existingClientGroupForm.json';
import useClientGroupOptions from './useClientGroupOptions';

const useExistingClientGroupForm = () => {
  const { clientGroupOptions, isLoading } = useClientGroupOptions();

  const [updated, setUpdated] = useState(false);
  const [existingClientGroupFormSchema, setSchema] = useState<RJSFSchema>(
    existingClientGroupForm as RJSFSchema
  );

  useEffect(() => {
    if (clientGroupOptions) {
      const oneOf = [
        ...Object.values(clientGroupOptions).map((client: any) => ({
          const: client.GroupId,
          title: client.ClientNames.join(', '),
        })),
      ];

      setSchema((schema) => {
        schema = Object.assign({}, schema, {
          properties: Object.assign({}, schema.properties, {
            GroupId: Object.assign({}, schema.properties.GroupId, {
              oneOf: oneOf,
            }),
          }),
        });

        return schema;
      });
      setUpdated(true);
    }
  }, [clientGroupOptions]);

  return {
    existingClientGroupFormSchema,
    isLoading,
    updated,
  };
};
export default useExistingClientGroupForm;
